<template>
	<div id="index">
		<div id='idsum'>
			<el-row :gutter="24">
				<!-- <el-col  :span='6'>
          <div class='idscell'>
            <el-row>
              <el-col :span='12'>
                <label>总销售额</label>
              </el-col>
              <el-col :span='12' style="text-align: right;">
                <img :src='isale'/>
              </el-col>
            </el-row>
            <el-row>
              ￥<label>{{totalSales}}</label>
            </el-row>
            <el-row>
              昨日销售额<label style="color:rgba(255,77,79,1);">¥{{yesterdayTotalSales}}</label>
            </el-row>
          </div>
        </el-col> -->
				<el-col :span='12'>
					<div class='idscell'>
						<el-row>
							<el-col :span='12'>
								<label>{{ $t('app_all_total') }}</label>
							</el-col>
							<el-col :span='12' style="text-align: right;">
								<img :src='ipay' />
							</el-col>
						</el-row>
						<el-row>
							<label>{{totalNum}}</label>{{ $t('app_strokes') }}
						</el-row>
						<el-row>
							{{ $t('app_yesterday_total') }}<label style="color:rgba(64,169,255,1);">{{yesterdayTotalNum}}{{ $t('app_strokes') }}</label>
						</el-row>
					</div>
				</el-col>
				<el-col :span='12'>
					<div class='idscell'>
						<el-row>
							<el-col :span='12'>
								<label>{{ $t('app_device_total') }}</label>
							</el-col>
							<el-col :span='12' style="text-align: right;">
								<img :src='iequip' />
							</el-col>
						</el-row>
						<el-row>
							<label>{{totalDevice}}</label>{{ $t('app_units') }}
						</el-row>
						<el-row>
							{{ $t('app_yesterday_active') }}<label style="color:rgba(115,209,61,1);">{{yesterdayTotalDevice}}{{ $t('app_units') }}</label>
						</el-row>
					</div>
				</el-col>
				<!-- <el-col  :span='6'>
          <div class='idscell'>
            <el-row>
              <el-col :span='12'>
                <label>商户总数</label>
              </el-col>
              <el-col :span='12' style="text-align: right;">
                <img :src='imerchant'/>
              </el-col>
            </el-row>
            <el-row>
              <label>{{totalUser}}</label>
            </el-row>
            <el-row>
              昨日收款商户<label style="color:rgba(255,197,61,1);">{{yesterdayUser}}</label>
            </el-row>
          </div>
        </el-col> -->
			</el-row>
		</div>
		<div class='grlmg gsttop gnmrd'>
			<div id='idtabtool'>
				<div id='idttgpbtn'>
					<label v-for='(item,index) in idtData.data' :key='item.vl'
						:class="index == idtData.index?'idtgplb-select':'idtgplb'"
						@click='gplbClick(index)'>{{item.lb}}</label>
				</div>
				<el-date-picker style='width: 256px;float:right;' size='small' @change='dateChange' v-model="pkdate"
					value-format='yyyy-MM-dd' type="daterange" range-separator="~" :start-placeholder="$t('app_start_time')"
					:end-placeholder="$t('app_end_time')" :picker-options="validDateRange" :default-value="defaultTimeBegin">
				</el-date-picker>
			</div>
			<el-tabs v-model="activeName" @tab-click="tabClick">
				<el-tab-pane :label="$t('app_device_equi')" name="sale"></el-tab-pane>
				<el-tab-pane :label="$t('app_broad_statis')" name="pay"></el-tab-pane>
			</el-tabs>
			<!-- <div style="height: 1000px;"></div> -->
			<div id="idecct" style=""></div>
		</div>
	</div>
</template>

<style>
	#idsum {
		overflow: hidden;
		width: 100%;
		width: calc(100% - 48px);
		height: 158px;
		margin: 24px 0 0 24px;
	}

	.idscell {
		height: 158px;
		background: white;
		border-radius: 2px;
		padding: 16px 16px 0 24px;
		overflow: hidden;
	}

	.idscell .el-row:nth-child(1) {
		height: 40px;
		line-height: 40px;
	}

	.idscell .el-row:nth-child(1) label {
		color: rgba(0, 0, 0, 0.45);
		font-weight: 400;
		font-size: 14px;
	}

	.idscell .el-row:nth-child(1) img {
		width: 40px;
		height: 40px;
	}

	.idscell .el-row:nth-child(2) {
		text-align: left;
	}

	.idscell .el-row:nth-child(2) label {
		font-weight: 800;
		color: rgba(0, 0, 0, 0.85);
		font-size: 30px;
	}

	.idscell .el-row:nth-child(3) {
		margin-top: 16px;
		font-size: 14px;
		font-weight: 400;
		color: rgba(0, 0, 0, 0.65);
	}

	.idscell .el-row:nth-child(3) label {
		margin-left: 8px;
		font-size: 14px;
		font-weight: bold;
	}

	#idtabtool {
		overflow: hidden;
		z-index: 999;
		position: absolute;
		height: 32px;
		width: 60%;
		margin-top: 8px;
		right: 24px;
		text-align: right;
		line-height: 30px;
		padding-right: 32px;
		display: inline-block;
		background: white;
	}

	#idttgpbtn {
		margin-right: 32px;
		display: inline-block;
		overflow: hidden;
	}

	#idttgpbtn label {
		font-weight: 400;
		padding-left: 24px;
		cursor: pointer;
	}

	.idtgplb {
		color: rgba(0, 0, 0, 0.65);
	}

	.idtgplb-select {
		color: rgba(24, 144, 255, 1);
	}

	#idecct {
		width: 100%;
		height: 471px;
		margin-bottom: 24px;
	}
</style>

<script>
	import echarts from 'echarts';
	import dayjs from 'dayjs';
	import 'dayjs/locale/zh-cn';
	dayjs.locale('zh-cn');

	export default {
		data() {
			return {
				chart: '',
				isale: require('@/assets/index/sale.svg'),
				ipay: require('@/assets/index/pay.svg'),
				iequip: require('@/assets/index/equip.svg'),
				imerchant: require('@/assets/index/merchant.svg'),
				activeName: 'sale',
				sclock: false,
				pkdate: '',
				idtData: {
					index: 0,
					data: [{
							lb: '24' + this.$t('app_hour'), 
							vl: 0
						},
						{
							lb: '7' + this.$t('app_day'),
							vl: 1
						},
						{
							lb: '30' + this.$t('app_day'),
							vl: 2
						}
						//{lb: '全年', vl: 3}
					]
				},
				totalSales: '', //总销售额
				yesterdayTotalSales: '', //昨日销售额
				totalNum: '', //总支付笔数
				yesterdayTotalNum: '', //昨日支付笔数
				totalDevice: '', //总设备数
				yesterdayTotalDevice: '', //昨日收款设备数
				totalUser: '', //商户总数
				yesterdayUser: '', //昨日收款商户总数
				myChart: null,
				start: '',
				end: '',
				validDateRange: {
					disabledDate: (time) => {
						//console.log('时间是'+time.getTime());
						//console.log("现在时间"+Date.now());
						var beginRange = dayjs().startOf("day").subtract(29, "day");
						//console.log("30天开始："+beginRange.format("YYYY-MM-DD HH:mm:ss"));
						//console.log("30天时间戳："+beginRange.valueOf());
						return time.getTime() > Date.now() || time.getTime() < beginRange.valueOf(); //注意是||不是&&
					}
				},
				defaultTimeBegin: ''
			}
		},

		beforeMount: function() {
			//加载统计数据
			this.loadSumData();
			//加载图表统计数据
			this.gplbClick(0);
			//设置时间选择控件显示的开始月份
			var beginDate = new Date();
			beginDate.setMonth(new Date().getMonth() - 1);
			this.defaultTimeBegin = beginDate;
		},
		mounted() {
			this.initEc()
			window.onresize = this.chart.resize;
		},
		methods: {
			initEc() {
				var dom = document.getElementById("idecct")
				var myChart = echarts.init(dom)
				var option = null
				option = {
					tooltip: {
						trigger: 'axis',
						axisPointer: { // 坐标轴指示器，坐标轴触发有效
							type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
						}
					},
					legend: {
						data: ['离线'],
						//data:['云支付','支付宝','京东'],
						y: 'bottom',
						padding: [0, 0, 20, 0]
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '12%',
						containLabel: true
					},
					xAxis: [{
						type: 'category',
						// data : ['2019-03-17','2019-03-18','2019-03-19','2019-03-20','2019-03-21','2019-03-22','2019-03-23']
						data: []
					}],
					yAxis: [{
						type: 'value'
					}],
					series: [{
							name: '0',
							type: 'bar',
							color: '#73D13D',
							stack: '广告',
							// data:[120, 132, 101, 134, 90, 230, 210]
							data: []
						},
						{
							name: '1',
							type: 'bar',
							color: '#73D13D',
							stack: '广告',
							// data:[120, 132, 101, 134, 90, 230, 210]
							data: []
						},
						{
							name: '2',
							type: 'bar',
							color: '#1890FF',
							stack: '广告',
							// data:[220, 182, 191, 234, 290, 330, 310]
							data: []
						},
						{
							name: '京东',
							type: 'bar',
							color: '#c91623',
							stack: '广告',
							// data:[220, 182, 191, 234, 290, 330, 310]
							data: []
						}
					]
				}
				if (option && typeof option === "object") {
					myChart.setOption(option, true)
					this.chart = myChart
				}
			},
			loadSumData() {
				this.$queryIndexTotalSumData((response) => {
					var data = response.data;
					this.totalSales = data.totalSales;
					this.yesterdayTotalSales = data.yesterdayTotalSales;
					this.totalNum = data.totalNum;
					this.yesterdayTotalNum = data.yesterdayTotalNum;
					this.totalDevice = data.totalDevice;
					this.yesterdayTotalDevice = data.yesterdayTotalDevice;
					this.totalUser = data.totalUser;
					this.yesterdayUser = data.yesterdayUser;
					//console.log(data);
				}, () => {
					//this.$message('统计数据加载失败');
				})

			},
			gplbClick(index) {
				//先清空日期选择框
				this.pkdate = null;
				this.idtData.index = index;

				/**
				 * 根据index封装时间，时间格式"YYYY-MM-DD"，可根据需要调整成"YYYY-MM-DD HH:mm:ss"
				 */
				if (index == 0) {
					//console.log("24小时");
					this.start = dayjs().startOf('hour').subtract(23, 'hour').format("YYYY-MM-DD HH:mm:ss");
					this.end = dayjs().endOf('hour').subtract(0, 'hour').format("YYYY-MM-DD HH:mm:ss");
					//console.log(this.start);
					//console.log(this.end);

				} else if (index == 1) {
					//console.log("7天");
					this.start = dayjs().startOf('day').subtract(6, 'day').format("YYYY-MM-DD HH:mm:ss");
					this.end = dayjs().endOf('day').subtract(0, 'day').format("YYYY-MM-DD HH:mm:ss");
					//console.log(this.start);
					//console.log(this.end);
				} else if (index == 2) {
					//console.log("30天");
					this.start = dayjs().startOf('day').subtract(29, 'day').format("YYYY-MM-DD HH:mm:ss");
					this.end = dayjs().endOf('day').subtract(0, 'day').format("YYYY-MM-DD HH:mm:ss");
					//console.log(this.start);
					//console.log(this.end);

				} else if (index == 3) {
					//console.log("全年")
					this.start = dayjs().startOf('year').format("YYYY-MM-DD HH:mm:ss");
					this.end = dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss");
					// console.log(this.start);
					// console.log(this.end);

				}
				this.queryBarData()
			},
			dateChange(vl) {
				//将索引设置为一个不存在的值，这样所有的选项不会被选中
				if (!vl) {
					this.gplbClick(0)
					return
				}
				this.idtData.index = -1;
				var startTime = vl[0];
				var endTime = vl[1];

				this.start = startTime + " 00:00:00";
				this.end = endTime + " 23:59:59";
				//console.log(this.start);
				//console.log(this.end);
				this.queryBarData();
			},

			tabClick(val) {
				//console.log("tab被点击");
				this.queryBarData()

			},


			queryBarData() {
				var type
				if (this.activeName == 'sale') {
					//设备统计
					type = '0,1,2' //0 离线 1 活跃 2未初始化
					this.$homestEq(this.start, this.end, type, (response) => {
						var data = response.data;
						var option = this.chart.getOption();
						option.legend[0].data = [this.$t('app_active'), this.$t('app_off_line'), this.$t('app_un_init')]
						option.series[1].data = data['0'].reverse();
						option.series[1].color = '#F36C60'
						option.series[1].name = this.$t('app_off_line')
						option.series[2].data = data['1'].reverse();
						option.series[2].color = '#1890FF'
						option.series[2].name = this.$t('app_active')
						option.series[0].data = data['2'].reverse();
						option.series[0].color = '#CDCDCD'
						option.series[0].name = this.$t('app_un_init')

						option.series[3].data = []
						////....
						option.xAxis[0].data = data['date'].reverse();
						this.chart.setOption(option)
					}, () => {
						//this.$message('统计数据加载失败');
					})
				} else {
					//播报统计
					type = 'offline,send,succeed,error' //offline,send,succeed,error      
					this.$homestPl(this.start, this.end, type, (response) => {
						var data = response.data;
						var option = this.chart.getOption();
						option.legend[0].data = [this.$t('app_success'), this.$t('app_pushed'),  this.$t('app_device_ofline'), this.$t('app_failed')]
						option.series[0].data = data['error'].reverse();
						option.series[0].color = '#F36C60'
						option.series[0].name = this.$t('app_failed')
						option.series[1].data = data['send'].reverse();
						option.series[1].color = '#1890FF'
						option.series[1].name = this.$t('app_pushed')
						option.series[2].data = data['offline'].reverse();
						option.series[2].color = '#F5A623'
						option.series[2].name = this.$t('app_device_ofline')
						option.series[3].data = data['succeed'].reverse();
						option.series[3].color = '#6AC95A'
						option.series[3].name = this.$t('app_success')
						/////....
						option.xAxis[0].data = data['date'].reverse();
						this.chart.setOption(option)
					}, () => {
						//this.$message('统计数据加载失败');
					})
				}
			}


		},

	}
</script>
